import Vue from 'vue'
import Router from 'vue-router'
import clientList from '../page/myClient/clientList.vue'
import clientDetail from '../page/myClient/detail.vue'
import releaseClientJob from '../page/release/clientJob.vue' //代下单 - 客户
import releaseClientJobResult from '../page/release/clientJobResult.vue' //代下单 - 发布成功 - 客户
import releaseClientJobList from '../page/release/clientJobList.vue' //代下单 - 发单列表 - 客户
import releaseClientJobDetail from '../page/release/clientJobDetail.vue' //代下单 - 发单详情 - 客户
import distributedOrderList from '../page/user/distributedOrderList.vue' //用户中心 - 派单列表
import jobDetail from '../page/jobDetail.vue' //用户中心 - 派单详情
import serverList from '../page/server/serverList.vue'
// import addAunt from '../page/server/addAunt.vue'
import serverProfile from '../page/server/serverProfile.vue' //用户中心 - 添加|编辑服务人员信息
import serverDetail from '../page/server/serverDetail.vue' //阿姨详情
import matchJob from '../page/server/matchJob.vue'
import qdList from '../page/home/qdList.vue'
import salary from '../page/home/salary.vue'
// import center from '../page/center.vue'
import center from '../page/user/center.vue' //用户中心
import myAccount from '../page/myAccount.vue'

import storeApply from '../page/storeApply.vue'
//import deposit from '../page/deposit.vue'
import payDeposit from '../page/pay/deposit.vue'
import payBalance from '../page/pay/balance.vue'
import serviceHelp from '../page/service/help.vue' //帮助中心 - 列表
import downloadLanding from '../page/service/download-landing.vue' //下载着陆页

Vue.use(Router);

export default new Router({
    routes: [
        //{
        //    path: '/deposit',
        //    name: 'deposit',
        //    component: deposit
        //},
        {
            path: '/myAccount',
            name: 'myAccount',
            component: myAccount
        },
        {
            path: '/storeApply',
            name: 'storeApply',
            component: storeApply
        },
        {
            path: '/clientList',
            name: 'clientList',
            component: clientList
        },
        {
            path: '/clientDetail/:id',
            name: 'clientDetail',
            component: clientDetail
        },
        {
            path: '/release/clientJob',
            name: 'releaseClientJob',
            component: releaseClientJob
        },
        {
            path: '/release/clientJobResult',
            name: 'releaseClientJobResult',
            component: releaseClientJobResult
        },
        {
            path: '/release/clientJobList/:tabid',
            name: 'releaseClientJobList',
            component: releaseClientJobList
        },
        {
            path: '/release/clientJobDetail/:ordernum',
            name: 'releaseClientJobDetail',
            component: releaseClientJobDetail
        },
        {
            path: '/distributedOrderList',
            name: 'distributedOrderList',
            component: distributedOrderList
        },
        {
            path: '/jobDetail',
            name: 'jobDetail',
            component: jobDetail
        },
        {
            path: '/serverList',
            name: 'serverList',
            component: serverList
        },
        // {
        //     path: '/addAunt',
        //     name: 'addAunt',
        //     component: addAunt
        // },
        {
            path: '/serverProfile',
            name: 'serverProfile',
            component: serverProfile
        },
        {
            path: '/serverDetail/:servantId/:jobId',
            name: 'serverDetail',
            component: serverDetail,
            meta: {
                title: '服务'
            },
        },
        {
            path: '/matchJob',
            name: 'matchJob',
            component: matchJob
        },
        {
            path: '/qdList',
            name: 'qdList',
            component: qdList
        },
        {
            path: '/salary',
            name: 'salary',
            component: salary
        },
        {
            path: '/center',
            name: 'center',
            component: center
        },
        {
            path: '/pay/deposit',
            name: 'payDeposit',
            component: payDeposit
        },
        {
            path: '/pay/balance',
            name: 'payBalance',
            component: payBalance
        },
        {
            path: '/service/help',
            name: 'serviceHelp',
            component: serviceHelp
        },
        {
            path: '/downloadLanding',
            name: 'downloadLanding',
            component: downloadLanding
        },
        {
            path: '*',
            redirect: "/qdList"
        }
    ]
})


// WEBPACK FOOTER //
// ./src/ally/router/index.js